module.exports = __webpack_public_path__ + "img/boc.1cff8b84.jpg";